/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function WarningOutlineIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "warning-outline", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M19.101 20.5H5.89903C4.37406 20.5 3.41013 18.8618 4.15072 17.5287L10.7517 5.64697C11.5137 4.27535 13.4863 4.27535 14.2483 5.64697L20.8493 17.5287C21.5899 18.8618 20.6259 20.5 19.101 20.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 17V15.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 10V14", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(WarningOutlineIcon);
export default ForwardRef;
//# sourceMappingURL=warningOutlineIcon.js.map